import { GetCycleItemInfoResponse } from '../api-services/get-cycle-item-info.service';
import { CatalogInfo } from './catalog-info.model';
import { ItemInfo } from './item-info.model';

/**
 * サイクル設定画面の商品情報クラス(編集可能項目のみ)
 *
 * @export ItemEditableInfo
 * @class ItemEditableInfo
 */
export class ItemEditableInfo {
  mediumType: string;
  pcode: string;
  categoryTagId: string;
  goodsMemo: string;
  catalogInfoMap: { [key: string]: string };
  catalogMemoMap: { [key: string]: string };

  constructor(data: GetCycleItemInfoResponse['CycleItemInfoList'][number]) {
    this.mediumType = data.MediumType;
    this.pcode = data.Pcode;
    this.categoryTagId = data.CategoryTagId;
    this.goodsMemo = data.GoodsMemo;
    if (ItemInfo.FLAG_TRUE === data.EnableSet) {
      const obj: { [key: string]: string } = {};
      data.CatalogInfoList.filter(
        _ => CatalogInfo.STATUS_EDITABLE === _.Status
      ).forEach(_ => (obj[_.OrderCode] = _.PricePattern));
      this.catalogInfoMap = obj;

      const memoObj: { [key: string]: string } = {};
      data.CatalogInfoList.forEach(_ => (memoObj[_.OrderCode] = _.CatalogMemo));
      this.catalogMemoMap = memoObj;
    } else {
      this.catalogInfoMap = {};
      this.catalogMemoMap = {};
    }
  }
}
